import {CampaignProps} from '@/types/campaign';
import {BriefFieldManagerAttributes} from '@/views/campaigns/brief/brief-field-manager/BriefFieldManager';
import BriefField from '@/views/campaigns/brief/brief-field-manager/brief-field/BriefField';
import ContentAgreementBriefItem from '@/views/campaigns/brief/brief-field-manager/brief-field/ContentAgreementBriefItem';

class ContentAgreementTerms extends BriefField {
  briefFieldManager: BriefFieldManagerAttributes;

  constructor(
    briefFieldManager: BriefFieldManagerAttributes,
    campaignData: CampaignProps,
    key: string,
    value: any
  ) {
    super(briefFieldManager, campaignData, key, value);
    this.briefFieldManager = briefFieldManager;
  }

  set value(value: any) {
    super.value = value;
    if (this.briefFieldManager.fields.contentAgreementBriefItem) {
      (
        this.briefFieldManager.fields
          .contentAgreementBriefItem as ContentAgreementBriefItem
      ).contentAgreementTerms = value;
    }
  }

  get value() {
    return super.value;
  }
}

export default ContentAgreementTerms;
